import { environment as dev } from './environment.dev';
import { environment as prod } from './environment.prod';

const devMode = true;

export const environment = {
  ...(devMode ? dev : prod),
  useSentry: false,
  useSmartlook: false,
  urlApp: 'https://dev5.pyjam.com',
  urlBackEnd: 'https://dev5.pyjam.com',
  urlBackEndApi: 'https://dev5.pyjam.com/api',
  socketConfig: {
    url: 'https://dev5.pyjam.com',
    options: {autoConnect: false, transports: ['websocket', 'polling'], tryAllTransports: true},
  },
};
